function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { getStreamQualityConfig } from './stream-quality-config';
function customDeviceManifestDashConfiguration(propositionConfig, deviceType, playoutData) {
    var dashConfiguration = propositionConfig === null || propositionConfig === void 0 ? void 0 : propositionConfig.dash;
    if (dashConfiguration) {
        var _dashConfiguration_deviceType;
        var customDeviceConfiguration = (_dashConfiguration_deviceType = dashConfiguration[deviceType]) === null || _dashConfiguration_deviceType === void 0 ? void 0 : _dashConfiguration_deviceType.customDeviceConfiguration;
        if (customDeviceConfiguration) {
            return customDeviceConfiguration(playoutData);
        }
    }
    return undefined;
}
export function getDashManifestConfig(propositionDashManifestConfig, deviceType, playbackTypeKey, playoutData) {
    var _propositionDashManifestConfig_dash_deviceType, _propositionDashManifestConfig_dash, _propositionDashManifestConfig_dash_default, _propositionDashManifestConfig_dash1;
    var customDeviceConfiguration = customDeviceManifestDashConfiguration(propositionDashManifestConfig, deviceType, playoutData);
    var playbackTypeConfig = (propositionDashManifestConfig === null || propositionDashManifestConfig === void 0 ? void 0 : (_propositionDashManifestConfig_dash = propositionDashManifestConfig.dash) === null || _propositionDashManifestConfig_dash === void 0 ? void 0 : (_propositionDashManifestConfig_dash_deviceType = _propositionDashManifestConfig_dash[deviceType]) === null || _propositionDashManifestConfig_dash_deviceType === void 0 ? void 0 : _propositionDashManifestConfig_dash_deviceType[playbackTypeKey]) || {};
    var _propositionDashManifestConfig_dash_default_playbackTypeKey;
    var defaultDashManifestConfig = (_propositionDashManifestConfig_dash_default_playbackTypeKey = propositionDashManifestConfig === null || propositionDashManifestConfig === void 0 ? void 0 : (_propositionDashManifestConfig_dash1 = propositionDashManifestConfig.dash) === null || _propositionDashManifestConfig_dash1 === void 0 ? void 0 : (_propositionDashManifestConfig_dash_default = _propositionDashManifestConfig_dash1.default) === null || _propositionDashManifestConfig_dash_default === void 0 ? void 0 : _propositionDashManifestConfig_dash_default[playbackTypeKey]) !== null && _propositionDashManifestConfig_dash_default_playbackTypeKey !== void 0 ? _propositionDashManifestConfig_dash_default_playbackTypeKey : {};
    var dashManifestStreamQualityConfig = getStreamQualityConfig(playbackTypeConfig, defaultDashManifestConfig, playoutData);
    return _object_spread({}, dashManifestStreamQualityConfig !== null && dashManifestStreamQualityConfig !== void 0 ? dashManifestStreamQualityConfig : {}, customDeviceConfiguration !== null && customDeviceConfiguration !== void 0 ? customDeviceConfiguration : {});
}

//# sourceMappingURL=manifest-dash-config.js.map